import React from 'react';
import Processing from './processing';
import Watermark from './watermark';

export default function SimpleLoader() {

    return (
        <div className="page template-intro">
          <div className="page__background">
            <Watermark/>
          </div>
          <div className="page__container">
            <section className="page__header"/>
            <section className="page__content">
              <Processing/>
            </section>
          </div>
        </div>
    );
}
